// TikTok standard events Releva can send server-side (Events API), and the
// Releva activity that produces each. Must stay in sync with
// TIKTOK_EVENT_NAMES in magellan-api (helpers/tiktok/tiktok-event-dispatcher.js)
// — the admin API rejects any name outside that set with a 400.
//
// Deliberately absent: PageView and AddPaymentInfo (TikTok's Events API has no
// standard counterpart, so Releva never sends them) and `custom/*` events
// (Releva event names with no standard-event twin — never gated).
//
// A NULL enabledTrackingEvents column means "legacy: send everything", so the
// picker renders NULL as the full set; only a touched (explicit array) value
// is written back.
export const TIKTOK_TRACKING_EVENTS = [
  { value: 'ViewContent', source: 'a tracked product view' },
  { value: 'AddToCart', source: 'products added to the cart' },
  { value: 'InitiateCheckout', source: 'a started checkout' },
  { value: 'Purchase', source: 'a completed order' },
  { value: 'AddToWishlist', source: 'products added to the wishlist' },
  { value: 'Search', source: 'an on-site search' },
  { value: 'CompleteRegistration', source: 'a new registration' },
  { value: 'Subscribe', source: 'a newsletter subscribe captured by Releva' },
];

export const TIKTOK_TRACKING_EVENT_NAMES = TIKTOK_TRACKING_EVENTS.map((event) => event.value);
